
export default
  name: 'wallpaper'
  props:    
    wallpaper:
        required: true
        type: String
  render: (h) ->    
    h('style', { id: 'wallpaper' }, "#app { background: url(#{@wallpaper})  no-repeat center center/cover fixed !important }")    
